import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TextField, Checkbox } from 'redux-form-material-ui';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import { push } from 'react-router-redux';
import _ from 'lodash';

import AlertDialog from '../../Common/AlertDialog';
import { registerFormHandler, fetchStaticRoutine } from '../../../routines';
import { toArray } from '../../../utils/helper';
import { required, email, password } from '../../../utils/formvalidation';
import { showError, isDialogOpen } from '../../../actions/dialogs';

import styles from './styles';
import LoadingOverlay from '../../Common/LoadingOverlay';

class Register extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    dialogs: PropTypes.object.isRequired,
    showError: PropTypes.func.isRequired,
    acceptedTAC: PropTypes.bool,
  };

  state = {
    message: '',
  };

  componentWillMount() {
  }

  render() {
    const { handleSubmit, acceptedTAC, submitting } = this.props;

    return (
      <div style={styles.container}>

        <div style={styles.logoContainer}><img alt="Logo" src="/images/logo.png"/></div>

        <Paper style={styles.paper} zDepth={5}>
          <form style={styles.form} onSubmit={handleSubmit(registerFormHandler)}>
            <div style={styles.row}>
              <Field
                name="firstName"
                component={TextField}
                type="text"
                style={styles.input}
                fullWidth
                floatingLabelFixed
                floatingLabelText="First Name"
                validate={[required]}
              />
              <Field
                name="lastName"
                component={TextField}
                type="text"
                style={styles.input}
                fullWidth
                floatingLabelFixed
                floatingLabelText="Last Name"
                validate={[required]}
              />
              <Field
                name="mobile"
                component={TextField}
                type="text"
                style={styles.input}
                fullWidth
                floatingLabelFixed
                floatingLabelText="Mobile"
                validate={[required]}
              />
            </div>

            <div style={styles.row}>
              <Field
                name="email"
                component={TextField}
                type="email"
                style={styles.input}
                fullWidth
                floatingLabelFixed
                floatingLabelText="Email"
                validate={[required, email]}
              />
              <div className="form-group">
                <Field
                  name="password"
                  component={TextField}
                  type="password"
                  style={styles.input}
                  fullWidth
                  floatingLabelFixed
                  floatingLabelText="Password"
                  validate={[required, password]}
                />
              </div>
            </div>

            <div style={styles.row}>
              <Field
                name="acceptedTAC"
                component={Checkbox}
                labelStyle={{ zIndex: 3 }}
                label={<span>I accept the <a href="https://staza.io/terms-service.html" rel="noopener noreferrer" target="_blank">terms and conditions</a></span>}
                validate={[required]}
              />
            </div>

            <div>
              <center>
                <RaisedButton
                  type="submit"
                  label="Sign Up"
                  primary
                  style={styles.signup}
                  disabled={!acceptedTAC}/>
              </center>
              <center>
                <RaisedButton
                  type="button"
                  label="Login"
                  secondary
                  style={styles.login}
                  onClick={() => this.props.dispatch(push('/login'))}/>
              </center>
            </div>
          </form>
        </Paper>
        { isDialogOpen(this.props.dialogs, 'alert') ? <AlertDialog /> : null }

        <LoadingOverlay visible={submitting}/>
      </div>
    );
  }
}

const form = reduxForm({
  form: 'register',  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    // dispatch(setMessage('login', 'success', 'Registration was successful. Please check your emails to verify your email address'));
    dispatch(push('/login', { message: 'Registration was successful. Please check your email to verify your email address.' }));
  },
  onSubmitFail: (errors, dispatch, submitError) => {
    console.log('onSubmitFail', errors);
    if (_.keys(errors).length > 0) {
      dispatch(showError('Registration Failed', errors[_.keys(errors)[0]]));
    } else {
      dispatch(showError('Registration Failed', 'Unknown error'));
    }

  },
})(Register);

function mapStateToProps(state) {
  const selector = formValueSelector('register');
  return {
    dialogs: state.getIn(['dialogs', 'dialogs']).toJS(),
    industries: toArray(state.get('static').get('industries').toJS()),
    acceptedTAC: selector(state, 'acceptedTAC'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dispatch,
    fetchIndustries: () => fetchStaticRoutine.trigger({ type: 'industries' }),
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/Register/index.js